import { render, staticRenderFns } from "./ChangePhoneSMS.vue?vue&type=template&id=71603f16&scoped=true"
import script from "./ChangePhoneSMS.vue?vue&type=script&lang=js"
export * from "./ChangePhoneSMS.vue?vue&type=script&lang=js"
import style0 from "./ChangePhoneSMS.vue?vue&type=style&index=0&id=71603f16&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71603f16",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('71603f16')) {
      api.createRecord('71603f16', component.options)
    } else {
      api.reload('71603f16', component.options)
    }
    module.hot.accept("./ChangePhoneSMS.vue?vue&type=template&id=71603f16&scoped=true", function () {
      api.rerender('71603f16', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/common/ChangePhoneSMS.vue"
export default component.exports